<header class="navbar">
  <div class="titles-container">
    <div class="title-div">
      <img class="jumper-logo" src="assets/images/smokejumperLogoNoSubtitle.png" alt="Smokejumper Logo">
    </div>
    <h1 class="second-title">| Smokejumper Reporting System</h1>
  </div>
  <div class="profile-container">
    <div class="user-container">
      <span class="user">{{ getInfo('firstName') + ' ' + getInfo('lastName') }}</span>
      <span class="base">{{ getInfo('baseName') }} ({{ getInfo('baseCode') }})</span>  
    </div>
  </div>
</header>
<app-spinner [active]="isLoading"></app-spinner>
